module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.yml
// module id = 801
// module chunks = 1